import './setPublicPath'
import mod from '~entry'
export default mod
export * from '~entry'



// WEBPACK FOOTER //
// webpack://vue-slick-carousel/node_modules/@vue/cli-service/lib/commands/build/entry-lib.js